export default __webpack_public_path__ + "static/media/thiencau.71dca0d4.png";